/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.credentials.rpc.AchievementPublicRpc
 */
import * as References from './AchievementPublicRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.credentials.rpc.AchievementPublicRpc#getPublicAchievement
 */
export const GET_PUBLIC_ACHIEVEMENT_QUERY_FIELD_NAME = 'com_hubspot_credentials_rpc_AchievementPublicRpc_getPublicAchievement';
export const GET_PUBLIC_ACHIEVEMENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_ACHIEVEMENT_QUERY_FIELD_NAME,
  args: ['publicId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPublicAchievementRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.credentials.rpc.AchievementPublicRpc#getPublicAchievementV2
 */
export const GET_PUBLIC_ACHIEVEMENT_V2_QUERY_FIELD_NAME = 'com_hubspot_credentials_rpc_AchievementPublicRpc_getPublicAchievementV2';
export const GET_PUBLIC_ACHIEVEMENT_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_ACHIEVEMENT_V2_QUERY_FIELD_NAME,
  args: ['publicId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPublicAchievementV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});